export const itemPosition = {
    offset: 5, // Sets the offset width for each depth step
    yDistance: 4, // Sets the padding between menu items
    yPadding: 4, // Sets the vertical margin height for menu items
};
